(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-product-page"] && !Shopify.designMode) return;
  try {
    
  class CustomProduct {
    constructor(container) {
      this.container = container;
      this.sectionId = this.container.dataset.sectionId;
      this.productForm = this.container.querySelector('.product-form');
      if (!this.productForm) return;

      // Read dynamic data from data attributes
      this.currencySymbol = this.container.dataset.currencySymbol;
      this.addToCartText = this.container.dataset.addToCartText;
      this.soldOutText = this.container.dataset.soldOutText;

      this.variantData = JSON.parse(this.container.querySelector(`#ProductVariants-${this.sectionId}`).textContent);
      this.variantIdInput = this.productForm.querySelector('input[name="id"]');
      this.mainImageContainer = this.container.querySelector(`#MainImage-${this.sectionId}`);
      this.priceContainer = this.container.querySelector(`#Price-${this.sectionId}`);
      this.addToCartButton = this.productForm.querySelector('button[name="add"]');
      this.addToCartButtonText = this.addToCartButton.querySelector('span');
      this.thumbnails = this.container.querySelectorAll('.thumbnail');
      
      this.init();
    }

    init() {
      this.productForm.addEventListener('change', this.onVariantChange.bind(this));
      this.initQuantitySelector();
      this.initGallery();
    }
    
    onVariantChange() {
      const selectedOptions = Array.from(this.productForm.querySelectorAll('input[type=radio]:checked')).map(input => input.value);
      const currentVariant = this.variantData.find(variant => {
        return !variant.options.map((option, index) => {
          return selectedOptions[index] === option;
        }).includes(false);
      });

      if (!currentVariant) return;

      this.updateVariantInput(currentVariant);
      this.updatePrice(currentVariant);
      this.updateAddToCartButton(currentVariant);
      this.updateMedia(currentVariant);
    }
    
    updateVariantInput(variant) {
      this.variantIdInput.value = variant.id;
    }

    updatePrice(variant) {
      const originalPriceEl = this.priceContainer.querySelector('.original-price');
      const salePriceEl = this.priceContainer.querySelector('.sale-price');
      
      const formatMoney = (cents) => {
        return `${this.currencySymbol}${(cents / 100).toFixed(2)}`;
      }

      salePriceEl.textContent = formatMoney(variant.price);
      if (variant.compare_at_price > variant.price) {
        originalPriceEl.textContent = formatMoney(variant.compare_at_price);
        originalPriceEl.classList.remove('hidden');
      } else {
        originalPriceEl.classList.add('hidden');
      }
    }

    updateAddToCartButton(variant) {
      if (variant.available) {
        this.addToCartButton.disabled = false;
        this.addToCartButtonText.textContent = this.addToCartText;
      } else {
        this.addToCartButton.disabled = true;
        this.addToCartButtonText.textContent = this.soldOutText;
      }
    }
    
    updateMedia(variant) {
      if (!variant.featured_media) return;
      const newMedia = this.mainImageContainer.querySelector(`img`);
      newMedia.src = `${variant.featured_media.preview_image.src}&width=1200`;
      newMedia.alt = variant.featured_media.alt;
      
      this.thumbnails.forEach(thumb => {
        thumb.classList.toggle('active', thumb.dataset.mediaId == variant.featured_media.id);
      });
    }

    initQuantitySelector() {
      const quantityInput = this.productForm.querySelector('input[name="quantity"]');
      this.productForm.querySelectorAll('.quantity-btn').forEach(button => {
        button.addEventListener('click', () => {
          let currentValue = parseInt(quantityInput.value);
          if (button.name === 'plus') {
            quantityInput.value = currentValue + 1;
          } else if (button.name === 'minus' && currentValue > 1) {
            quantityInput.value = currentValue - 1;
          }
        });
      });
    }
    
    initGallery() {
        this.thumbnails.forEach(thumb => {
            thumb.addEventListener('click', (e) => {
                const newImageSrc = e.currentTarget.src.replace('_200x', '_1200x');
                this.mainImageContainer.querySelector('img').src = newImageSrc;
                
                this.thumbnails.forEach(t => t.classList.remove('active'));
                e.currentTarget.classList.add('active');
            });
        });

        const galleryImages = Array.from(this.thumbnails);
        if(galleryImages.length < 2) return;
        
        const mainImage = this.mainImageContainer.querySelector('img');
        
        const updateMainImageByIndex = (index) => {
             const newSrc = galleryImages[index].src.replace('_200x', '_1200x');
             mainImage.src = newSrc;
             this.thumbnails.forEach(t => t.classList.remove('active'));
             galleryImages[index].classList.add('active');
        }

        this.container.querySelector('.right-arrow').addEventListener('click', () => {
            const currentActive = this.container.querySelector('.thumbnail.active');
            let currentIndex = galleryImages.indexOf(currentActive);
            let nextIndex = (currentIndex + 1) % galleryImages.length;
            updateMainImageByIndex(nextIndex);
        });

        this.container.querySelector('.left-arrow').addEventListener('click', () => {
            const currentActive = this.container.querySelector('.thumbnail.active');
            let currentIndex = galleryImages.indexOf(currentActive);
            let prevIndex = (currentIndex - 1 + galleryImages.length) % galleryImages.length;
            updateMainImageByIndex(prevIndex);
        });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.custom-product-wrapper').forEach(container => {
      if (container) {
        new CustomProduct(container);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class CustomProduct {
    constructor(container) {
      this.container = container;
      this.sectionId = this.container.dataset.sectionId;
      this.productFormWrapper = this.container.querySelector('.product-form');
      this.formElement = this.productFormWrapper ? this.productFormWrapper.querySelector('form') : null;
      if (!this.formElement) return;
      this.currencySymbol = this.container.dataset.currencySymbol;
      this.addToCartText = this.container.dataset.addToCartText;
      this.soldOutText = this.container.dataset.soldOutText;
      const variantDataEl = this.container.querySelector(`#ProductVariants-${this.sectionId}`);
      if (!variantDataEl) return;
      this.variantData = JSON.parse(variantDataEl.textContent);
      const mediaMapEl = this.container.querySelector(`#VariantMediaMap-${this.sectionId}`);
      this.mediaMap = mediaMapEl ? JSON.parse(mediaMapEl.textContent) : {};
      this.mainImageContainer = this.container.querySelector(`#MainImage-${this.sectionId}`);
      this.thumbnailContainer = this.container.querySelector('.thumbnail-gallery');
      this.priceContainer = this.container.querySelector(`#Price-${this.sectionId}`);
      this.addToCartButton = this.container.querySelector('button[name="add"]');
      this.addToCartButtonText = this.addToCartButton ? this.addToCartButton.querySelector('span') : null;
      this.currentMediaList = [];
      this.init();
    }
    init() {
      const urlParams = new URLSearchParams(window.location.search);
      const variantIdFromUrl = urlParams.get('variant');
      if (variantIdFromUrl) {
         const initialVariant = this.variantData.find(v => v.id == variantIdFromUrl);
         if (initialVariant) this.updateUIForVariant(initialVariant);
      } else {
         const currentIdInput = this.formElement.querySelector('input[name="id"]');
         if (currentIdInput) {
            const initialVariant = this.variantData.find(v => v.id == currentIdInput.value);
            if (initialVariant) this.rebuildGallery(initialVariant);
         }
      }
      this.productFormWrapper.addEventListener('change', this.onOptionChange.bind(this));
      this.initQuantitySelector();
      this.initDelegatedGalleryListeners();
      this.initShareButton();
    }
    onOptionChange(event) {
      if (!event.target.matches('input[type="radio"]')) return;
      const selectedValue = event.target.value;
      const matchingVariants = this.variantData.filter(variant => variant.option1 === selectedValue || variant.option2 === selectedValue || variant.option3 === selectedValue);
      let bestVariant = matchingVariants.find(v => v.available) || matchingVariants[0];
      if (!bestVariant) return;
      this.updateHiddenInput(bestVariant);
      this.updateURL(bestVariant);
      this.updatePrice(bestVariant);
      this.updateAddToCartButton(bestVariant);
      this.rebuildGallery(bestVariant);
    }
    updateUIForVariant(variant) {
       const radios = this.formElement.querySelectorAll('input[type="radio"]');
       radios.forEach(radio => { if (radio.value === variant.option1 || radio.value === variant.option2 || radio.value === variant.option3) radio.checked = true; });
       this.updateHiddenInput(variant);
       this.rebuildGallery(variant);
       this.updatePrice(variant);
    }
    updateHiddenInput(variant) {
      const hiddenInput = this.formElement.querySelector('input[name="id"]');
      if (hiddenInput) { hiddenInput.value = variant.id; hiddenInput.dispatchEvent(new Event('change', { bubbles: true })); }
    }
    updateURL(variant) {
      if (!window.history.replaceState) return;
      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }
    updatePrice(variant) {
      const originalPriceEl = this.priceContainer.querySelector('.original-price');
      const salePriceEl = this.priceContainer.querySelector('.sale-price');
      const originalPriceAmountEl = originalPriceEl.querySelector('.price-amount');
      const salePriceAmountEl = salePriceEl.querySelector('.price-amount');
      const formatAmount = (cents) => (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      salePriceAmountEl.textContent = formatAmount(variant.price);
      if (variant.compare_at_price > variant.price) {
        originalPriceAmountEl.textContent = formatAmount(variant.compare_at_price);
        originalPriceEl.classList.remove('hidden');
      } else { originalPriceEl.classList.add('hidden'); }
    }
    updateAddToCartButton(variant) {
      if (!this.addToCartButton) return;
      if (variant.available) { this.addToCartButton.disabled = false; this.addToCartButtonText.textContent = this.addToCartText; } 
      else { this.addToCartButton.disabled = true; this.addToCartButtonText.textContent = this.soldOutText; }
    }
    rebuildGallery(variant) {
      if (!variant || !this.mediaMap || !this.thumbnailContainer) return;
      const galleryMedia = this.mediaMap[variant.id] || [];
      this.currentMediaList = galleryMedia;
      let featuredMediaToDisplay = variant.featured_media ? galleryMedia.find(m => m.id === variant.featured_media.id) : galleryMedia[0];
      const mainImage = this.mainImageContainer.querySelector('.main-product-image');
      if (mainImage && featuredMediaToDisplay) {
        mainImage.src = featuredMediaToDisplay.src_1200;
        mainImage.alt = featuredMediaToDisplay.alt || '';
        if (featuredMediaToDisplay.aspect_ratio) { mainImage.height = Math.round(1200 / featuredMediaToDisplay.aspect_ratio); mainImage.width = 1200; }
      }
      this.thumbnailContainer.innerHTML = '';
      galleryMedia.forEach(media => {
          const height = media.aspect_ratio ? Math.round(200 / media.aspect_ratio) : 200;
          const isActive = featuredMediaToDisplay && media.id === featuredMediaToDisplay.id;
          this.thumbnailContainer.insertAdjacentHTML('beforeend', `<img src="${media.src_200}" alt="${media.alt || ''}" width="200" height="${height}" class="thumbnail ${isActive ? 'active' : ''}" data-media-id="${media.id}" loading="lazy">`);
      });
      const navArrows = this.container.querySelector('.image-nav');
      if(navArrows) navArrows.style.display = galleryMedia.length > 1 ? 'flex' : 'none';
    }
    initQuantitySelector() {
      const quantityInput = this.container.querySelector('input[name="quantity"]');
      if(!quantityInput) return;
      this.container.querySelectorAll('.quantity-btn').forEach(button => {
        button.addEventListener('click', () => {
          let currentValue = parseInt(quantityInput.value);
          if (button.name === 'plus') quantityInput.value = currentValue + 1;
          else if (button.name === 'minus' && currentValue > 1) quantityInput.value = currentValue - 1;
        });
      });
    }
    initShareButton() {
      const shareButton = this.container.querySelector('.share-button');
      if (!shareButton) return;
      shareButton.addEventListener('click', () => {
        const productUrl = window.location.href;
        if (navigator.share) navigator.share({ title: document.title, url: productUrl }).catch(console.error);
        else navigator.clipboard.writeText(productUrl).then(() => { shareButton.classList.add('shared'); setTimeout(() => { shareButton.classList.remove('shared'); }, 2000); });
      });
    }
    updateActiveMedia(mediaId) {
        const numericMediaId = parseInt(mediaId, 10);
        const selectedMedia = this.currentMediaList.find(m => m.id === numericMediaId);
        if (selectedMedia) {
            const mainImage = this.mainImageContainer.querySelector('.main-product-image');
            mainImage.src = selectedMedia.src_1200;
            mainImage.alt = selectedMedia.alt || '';
            this.thumbnailContainer.querySelectorAll('.thumbnail').forEach(t => t.classList.remove('active'));
            const newActiveThumb = this.thumbnailContainer.querySelector(`.thumbnail[data-media-id="${numericMediaId}"]`);
            if (newActiveThumb) newActiveThumb.classList.add('active');
        }
    }
    initDelegatedGalleryListeners() {
        if (this.thumbnailContainer) this.thumbnailContainer.addEventListener('click', (e) => { if (e.target.classList.contains('thumbnail')) this.updateActiveMedia(e.target.dataset.mediaId); });
        const navContainer = this.container.querySelector('.image-nav');
        if (navContainer) navContainer.addEventListener('click', (e) => {
                const button = e.target.closest('.nav-arrow');
                if (!button) return;
                const galleryImages = Array.from(this.thumbnailContainer.querySelectorAll('.thumbnail'));
                if (galleryImages.length < 2) return;
                const currentActive = this.thumbnailContainer.querySelector('.thumbnail.active');
                let currentIndex = currentActive ? galleryImages.indexOf(currentActive) : 0;
                let nextIndex = button.classList.contains('right-arrow') ? (currentIndex + 1) % galleryImages.length : (currentIndex - 1 + galleryImages.length) % galleryImages.length;
                this.updateActiveMedia(galleryImages[nextIndex].dataset.mediaId);
            });
    }
  }
  const initCustomProductSections = () => { document.querySelectorAll('.custom-product-wrapper').forEach(container => { if (container && !container.classList.contains('js-initialized')) { new CustomProduct(container); container.classList.add('js-initialized'); } }); }
  document.addEventListener('DOMContentLoaded', initCustomProductSections);
  if (typeof Shopify !== 'undefined' && Shopify.designMode) document.addEventListener('shopify:section:load', initCustomProductSections);

  } catch(e) { console.error(e); }
})();
})();
